<template lang="pug">
shListData(title="Orders History" resolver="ordersHistory" keyData="_id" component="shOrder" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'OrdersHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/order/OrdersHistory.vue